<template>
    <div class="container">
      <h1>Ordenar Linhas</h1>
      <div class="converter-box">
        <textarea v-model="inputText" placeholder="Cole seu texto aqui, linha por linha"></textarea>
        <div class="button-group">
          <button @click="sortText(true)">Ordem Ascendente</button>
          <button @click="sortText(false)">Ordem Descendente</button>
        </div>
        <textarea ref="outputBox" v-model="outputText" readonly @click="copyToClipboard"></textarea>
        <p v-if="copied" class="copied-message">Texto copiado para a área de transferência! ✅</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "SortText",
    data() {
      return {
        inputText: "",
        outputText: "",
        copied: false
      };
    },
    methods: {
      sortText(ascending) {
        let lines = this.inputText.split("\n").filter(line => line.trim() !== "");
        lines = ascending ? lines.sort() : lines.sort().reverse();
        this.outputText = lines.join("\n");
        this.copyToClipboard();
      },
      copyToClipboard() {
        if (this.$refs.outputBox) {
          this.$refs.outputBox.select();
          document.execCommand("copy");
          this.copied = true;
          setTimeout(() => (this.copied = false), 2000);
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .button-group {
    display: flex;
    gap: 10px;
  }
  
  button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 18px;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s;
  }
  
  button:hover {
    background-color: #0056b3;
  }
  </style>
  